import React, { useEffect, useState } from 'react';
import { Table, Row, Col, Divider, Descriptions, Card, Typography, Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { creditNoteService } from '../../../../../services';
import './credit.css';

const { Title } = Typography;

const CreditPDF = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState([])
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)

    const columns = [
        { title: 'S.No', dataIndex: 'sno', key: 'sno' },
        { title: 'Credit Against Invoice Number', dataIndex: 'exp_v', key: 'exp_v', render: (text) => `Invoice# ${text}` },
        { title: 'Description', dataIndex: 'description', key: 'description' },
        { title: 'Amount (USD)', dataIndex: 'amount', key: 'amount', width: 250 },
    ];

    // const handlePrint = () => {
    //     const printContents = document.getElementById('printableArea').innerHTML;
    //     const originalContents = document.body.innerHTML;
    //     document.body.innerHTML = printContents;
    //     window.print();
    //     document.body.innerHTML = originalContents;
    //     window.location.reload();
    //     navigate('/accounts/credit-notes');
    // };

    const handlePrint = () => {
        window.print();
    }

    const initialize = async () => {
        setLoading(true)
        const { success, data } = await creditNoteService.getPDF(id)
        if (success) {
            setFormData(data);
            setData([
                {
                    key: '1',
                    sno: '1',
                    exp_v: data.credit.invoice_id,
                    description: data.credit.description,
                    amount: data.credit.amount,
                }
            ]);
        }
        setLoading(false)
    }

    useEffect(() => {
        initialize();
        const beforePrint = () => {
            console.log('Printing...');
        };

        const afterPrint = () => {
            navigate('/accounts/credit-notes');
        };

        window.addEventListener('beforeprint', beforePrint);
        window.addEventListener('afterprint', afterPrint);

        if (!loading) { handlePrint() };

        return () => {
            window.removeEventListener('beforeprint', beforePrint);
            window.removeEventListener('afterprint', afterPrint);
        };
    }, [loading]);

    return (
        <div style={{ display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: 'center', height: 'auto', width: "auto", backgroundColor: 'transparent', fontSize: '18px' }}>
            <Card id="printableArea" style={{ width: '100%', padding: 20 }}>
                <Row>
                    <Col span={24}>
                        <img src="/images/ctrade-logo.png" alt="Ctrade Logo" style={{ width: 80, height: 50, marginBottom: 20 }} />
                    </Col>
                </Row>
                {loading ? (
                    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Spin size="large" />
                    </div>
                ) : (
                    <>
                        <Row>
                            <Col span={24} style={{ textAlign: "center" }}>
                                <Title level={1} style={{ fontSize: '40px', textDecoration: "underline" }} >Credit Note</Title>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <div style={{ textAlign: 'right' }}>
                                    <p>3902 SWINGLE RD</p>
                                    <p>HOUSTON, TX 77047</p>
                                    <p>UNITED STATES</p>
                                    <p>Mobile: +1 832-819-2622</p>
                                    <p>Email: trade@ctrade.us</p>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} style={{ textAlign: "right", fontSize: 25 }}>
                                <div>
                                    <p><strong>Date:</strong> {formData?.credit?.issue_date}</p>
                                    <p><strong>Credit Note #:</strong> {formData?.credit?.id}</p>
                                </div>
                            </Col>
                        </Row>
                        <Divider style={{ borderTop: '2px solid #B83D3D' }} />
                        <Row gutter={20}>
                            <Col span={24}>
                                <Descriptions bordered column={1}>
                                    <Descriptions.Item label={<strong style={{ fontSize: 15 }}>Credit Note Issued To</strong>}>
                                        <span style={{ fontSize: 15 }}>{formData?.customer?.name}</span>
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<strong style={{ fontSize: 15 }}>Customer Address</strong>}>
                                        <span style={{ fontSize: 15 }}>{formData?.customer?.address}</span>
                                    </Descriptions.Item>
                                </Descriptions>
                            </Col>
                        </Row>
                        <Divider style={{ borderTop: '2px solid #B83D3D' }} />
                        <Row style={{ marginTop: 30 }}>
                            <Col span={24}>
                                <Table
                                    className="custom-table"
                                    columns={columns}
                                    dataSource={data}
                                    pagination={false}
                                    bordered
                                    summary={() => (
                                        <Table.Summary.Row style={{ fontSize: "18px", backgroundColor: "#B83D3D", color: "#FFFFFF" }}>
                                            <Table.Summary.Cell colSpan={2}></Table.Summary.Cell>
                                            <Table.Summary.Cell colSpan={1}><strong>Total Credit Amount(USD):</strong></Table.Summary.Cell>
                                            <Table.Summary.Cell><strong>${formData?.credit?.amount}</strong></Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    )}
                                />
                            </Col>
                        </Row>
                        <Divider style={{ borderTop: '2px solid #B83D3D' }} />
                        <Row>
                            <Col span={24} style={{ textAlign: "center", color: '#E0D7D4' }}>
                                <p>THANK YOU FOR DOING BUSINESS WIITH C TRADE USA INC.</p>
                            </Col>
                        </Row>
                    </>
                )}
            </Card>
        </div >
    );
}

export default CreditPDF;
